import { Col, Container, Row } from "reactstrap";
import { Apps, FileManager } from "../../../constants";
import FileContent from "./fileContent";
import SideBar from "./sideBar";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const FileManagerContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={FileManager} parent={Apps} />
      <Container fluid>
        <Row>
          <SideBar />
          <Col xl="9" md="12" className="box-col-12">
            <div className="file-content">
              <FileContent />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FileManagerContainer;
